export const CHECKOUT_URL =
  'https://herreria-y-muebles-industriales.impultienda.ar/checkout'

/* Todos los botones e imágenes llevan a la sección de compra */
export const OFFER_ANCHOR = '#oferta'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/eRYoW5EYexVZ2ptQy9aK2W/Mega_Pack_de_Herreria_y_Muebles.png'

export const PRODUCT_NAME = 'MEGA PACK HERRERÍA Y MUEBLES INDUSTRIALES DESDE CERO'

export const PRICE = '$19.990'
export const BONUS_VALUE = '$39.950'

/* 1. PROBLEMA */
export const problems = [
  {
    icon: 'layers' as const,
    title: 'INFORMACIÓN DISPERSA',
    desc: 'Guardás videos sobre soldadura, cortes, estructuras, hierro y madera, pero cada uno explica algo diferente y no sabés cómo conectar todo.',
  },
  {
    icon: 'help' as const,
    title: 'NO SABÉS QUÉ APRENDER PRIMERO',
    desc: 'Perfiles metálicos, mediciones, herramientas, soldadura, planos, armado, pintura... hay tantas técnicas y materiales que empezar parece complicado.',
  },
  {
    icon: 'route' as const,
    title: 'TE FALTA UNA RUTA',
    desc: 'Querés aprender una habilidad práctica que puedas convertir en trabajos por encargo, pero necesitás un camino desde los fundamentos hasta la fabricación y los presupuestos.',
  },
  {
    icon: 'clock' as const,
    title: 'SEGUÍS POSTERGANDO',
    desc: 'Querés comenzar, pero pasan las semanas y continuás mirando tutoriales en lugar de avanzar con un método organizado.',
  },
]

/* 2. SOLUCIÓN — 6 TOMOS */
export const tomos = [
  {
    icon: 'hammer' as const,
    title: 'FUNDAMENTOS DE HERRERÍA, MATERIALES Y HERRAMIENTAS',
    desc: 'Conocé los fundamentos de herrería, tipos de hierro, perfiles metálicos, herramientas, equipos de trabajo, seguridad y materiales utilizados para fabricar muebles industriales.',
  },
  {
    icon: 'ruler' as const,
    title: 'MEDICIONES, PLANOS Y PREPARACIÓN DE MATERIALES',
    desc: 'Aprendé a interpretar medidas, desarrollar planos, calcular materiales, preparar listas de cortes y organizar las piezas necesarias para cada proyecto.',
  },
  {
    icon: 'flame' as const,
    title: 'SOLDADURA, UNIONES Y ARMADO DE ESTRUCTURAS METÁLICAS',
    desc: 'Comprendé los fundamentos de soldadura, preparación de piezas, tipos de uniones, armado de estructuras, escuadras, refuerzos y controles de calidad.',
  },
  {
    icon: 'armchair' as const,
    title: 'FABRICACIÓN DE MUEBLES INDUSTRIALES PASO A PASO',
    desc: 'Aprendé a planificar mesas, escritorios, estanterías, bibliotecas y otros muebles industriales combinando estructuras metálicas con madera.',
  },
  {
    icon: 'paint' as const,
    title: 'TERMINACIONES, PINTURA Y ACABADOS PROFESIONALES',
    desc: 'Conocé técnicas de preparación de superficies, protección anticorrosiva, pintura, acabados para madera y controles para mejorar la presentación de tus muebles.',
  },
  {
    icon: 'calculator' as const,
    title: 'PROYECTOS COMPLETOS, PRESUPUESTOS Y TRABAJOS POR ENCARGO',
    desc: 'Aprendé a organizar proyectos completos, calcular materiales y costos, preparar presupuestos y comenzar a estructurar trabajos personalizados para clientes.',
  },
]

/* 3. BONOS */
export const bonuses = [
  {
    icon: 'compass' as const,
    title: '30 PLANOS DE MUEBLES INDUSTRIALES CON MEDIDAS',
    desc: '30 diseños de mesas, escritorios, estanterías y muebles para hogares y comercios, con medidas orientativas para planificar tus propios proyectos.',
    value: 'Valor: $7.990',
  },
  {
    icon: 'ruler' as const,
    title: 'GUÍA DE MATERIALES, CORTES Y CÁLCULO DE CANTIDADES',
    desc: 'Aprendé a calcular perfiles metálicos, madera, tornillos y consumibles, preparar listas de cortes, organizar compras y reducir desperdicios.',
    value: 'Valor: $5.990',
  },
  {
    icon: 'checks' as const,
    title: '20 PROYECTOS PRÁCTICOS PARA APRENDER HERRERÍA',
    desc: '20 ejercicios y proyectos organizados por dificultad para practicar mediciones, estructuras, planificación y fabricación de muebles industriales.',
    value: 'Valor: $6.990',
  },
  {
    icon: 'clipboard' as const,
    title: 'PLANTILLAS DE PRESUPUESTOS, COSTOS Y PRECIOS DE VENTA',
    desc: 'Plantillas y ejemplos para calcular materiales, mano de obra, gastos, precios de venta, ganancias y presupuestos para trabajos por encargo.',
    value: 'Valor: $8.990',
  },
  {
    icon: 'store' as const,
    title: 'GUÍA PARA EMPRENDER Y VENDER MUEBLES INDUSTRIALES',
    desc: 'Una guía para elegir productos, crear tu catálogo, promocionar muebles, atender clientes, organizar pedidos y comenzar tu emprendimiento.',
    value: 'Valor: $9.990',
  },
]

/* 4. BENEFICIOS */
export const benefits = [
  {
    icon: 'route' as const,
    title: 'MENOS CONFUSIÓN',
    desc: 'Dejá de saltar entre tutoriales y seguí una ruta desde los fundamentos de herrería hasta el diseño, armado y terminación de muebles industriales.',
  },
  {
    icon: 'book' as const,
    title: 'MÁS CONOCIMIENTO PRÁCTICO',
    desc: 'Comprendé herramientas, perfiles metálicos, mediciones, planos, soldadura, estructuras, madera, pintura y presupuestos con explicaciones organizadas.',
  },
  {
    icon: 'eye' as const,
    title: 'COMPRENDÉ LO QUE ESTÁS FABRICANDO',
    desc: 'Empezá a mirar una mesa, escritorio o estantería y reconocer sus materiales, medidas, uniones y estructura para planificar tus propios proyectos.',
  },
  {
    icon: 'award' as const,
    title: 'UNA NUEVA HABILIDAD',
    desc: 'Desarrollá conocimientos que pueden convertirse en el primer paso para fabricar tus muebles, realizar proyectos personalizados y ofrecer trabajos por encargo.',
  },
]

/* 5. TESTIMONIOS */
export const testimonials = [
  {
    quote:
      'Trabajo en un depósito y siempre me gustaron los muebles de hierro y madera, pero no sabía ni qué perfil comprar. Con el tomo de materiales entendí la diferencia entre caño estructural y planchuela, y con las listas de cortes armé mi primera mesa ratona para el living. Quedó firme y escuadrada.',
    author: 'Lucas Domínguez',
    role: 'Operario de logística, 31 años',
    location: 'Córdoba, Argentina',
  },
  {
    quote:
      'Hice algunos puntos de soldadura mirando videos, pero las estructuras me quedaban torcidas. El tomo de uniones y armado me enseñó a preparar las piezas, escuadrar antes de soldar y reforzar las esquinas. Fabriqué una estantería para el garage y ya no se mueve nada.',
    author: 'Ricardo Molina',
    role: 'Mecánico, 46 años',
    location: 'Rosario, Argentina',
  },
  {
    quote:
      'Quería decorar mi departamento con estilo industrial y los precios eran imposibles. Con los 30 planos elegí un escritorio, ajusté las medidas a mi espacio y lo hice con mi pareja en dos fines de semana. Lo que más me sirvió fue el tomo de terminaciones: la pintura quedó pareja y sin óxido.',
    author: 'Camila Ortiz',
    role: 'Diseñadora de interiores, 28 años',
    location: 'La Plata, Argentina',
  },
  {
    quote:
      'Me quedé sin trabajo y busqué algo práctico para generar ingresos. Empecé con los proyectos por dificultad y después usé las plantillas de presupuestos para cotizar. Ya vendí tres mesas de comedor y una barra para un bar del barrio, y sé exactamente cuánto gano en cada una.',
    author: 'Sebastián Acosta',
    role: 'Emprendedor, 38 años',
    location: 'Mendoza, Argentina',
  },
  {
    quote:
      'Toda la vida hice changas de albañilería y quería sumar algo nuevo. La guía para emprender me ayudó a armar un catálogo simple y publicarlo en redes. Hoy fabrico estanterías y mesas para locales y cafeterías de la zona, organizando cada pedido sin improvisar.',
    author: 'Jorge Benítez',
    role: 'Albañil y herrero, 52 años',
    location: 'Mar del Plata, Argentina',
  },
]

/* 6. FAQ */
export const faqs = [
  { q: '¿Es físico o digital?', a: 'Es un producto 100% digital.' },
  {
    q: '¿Necesito conocimientos previos?',
    a: 'No. El contenido comienza con los fundamentos de herrería, materiales y herramientas, y avanza progresivamente.',
  },
  {
    q: '¿Qué voy a aprender?',
    a: 'Materiales, herramientas, mediciones, planos, soldadura, uniones, estructuras metálicas, fabricación de muebles industriales, terminaciones, pintura y presupuestos.',
  },
  {
    q: '¿Incluye ejercicios?',
    a: 'Sí. Incluye 20 proyectos prácticos organizados por dificultad, 30 planos con medidas y ejemplos para aplicar lo aprendido.',
  },
  {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No. Los 5 bonos están incluidos en el precio del Mega Pack.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. Pagás una sola vez, sin mensualidades.',
  },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. El acceso al material digital se entrega después de confirmar el pago.',
  },
  {
    q: '¿Esto me habilita profesionalmente?',
    a: 'Es material educativo. No reemplaza la capacitación práctica supervisada, los procedimientos de seguridad ni las habilitaciones que puedan corresponder.',
  },
  {
    q: '¿Puedo aprender a mi ritmo?',
    a: 'Sí. Podés estudiar los tomos y realizar los proyectos según tu disponibilidad.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Podés escribir a soportescmdigital@gmail.com.',
  },
]

/* POP-UP DE COMPRAS RECIENTES — ARGENTINA */
export const recentBuyers = [
  { name: 'Javier Romero', city: 'Córdoba', minutes: 2 },
  { name: 'Marcelo Paz', city: 'Rosario', minutes: 4 },
  { name: 'Gustavo Herrera', city: 'Buenos Aires', minutes: 7 },
  { name: 'Andrés Medina', city: 'Mendoza', minutes: 11 },
  { name: 'Romina Castro', city: 'La Plata', minutes: 15 },
  { name: 'Pablo Giménez', city: 'Mar del Plata', minutes: 19 },
  { name: 'Sergio Aguirre', city: 'Salta', minutes: 24 },
  { name: 'Ezequiel Vera', city: 'San Miguel de Tucumán', minutes: 29 },
  { name: 'Matías Ledesma', city: 'Neuquén', minutes: 33 },
  { name: 'Hernán Quiroga', city: 'Santa Fe', minutes: 40 },
]
